import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const GA_ID = "G-LMTPTZVZCD";

export default function ScrollToTop() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
    // Track SPA route changes in Google Analytics 4
    if (typeof window.gtag === "function") {
      window.gtag("event", "page_view", {
        page_path: pathname + search,
        page_location: window.location.href,
        page_title: document.title,
        send_to: GA_ID,
      });
    }
  }, [pathname, search]);

  return null;
}
